/** Max increment per action = boot × 64 */
export const MAX_LIMIT_BOOT_MULTIPLIER = 64;

/** Pot showdown ceiling = boot × 256 */
export const POT_LIMIT_BOOT_MULTIPLIER = 256;

export function deriveMaxLimitFromBoot(bootAmount: number): number {
  const boot = Number(bootAmount);
  if (!Number.isFinite(boot) || boot < 0) return 0;
  return boot * MAX_LIMIT_BOOT_MULTIPLIER;
}

export function derivePotLimitFromBoot(bootAmount: number): number {
  const boot = Number(bootAmount);
  if (!Number.isFinite(boot) || boot < 0) return 0;
  return boot * POT_LIMIT_BOOT_MULTIPLIER;
}
